module.exports = __webpack_public_path__ + "static/Jana-dd32e3e9942635128721896eb76e1784.png";